module.exports = __webpack_public_path__ + "static/media/avatar.3f9d5f9c.png";